
import React from 'react';
import Navbar from '@/components/Navbar';
import ContactHero from '@/components/contact/ContactHero';
import ContactFormSection from '@/components/contact/ContactFormSection';
import MapSection from '@/components/contact/MapSection';
import FAQSection from '@/components/contact/FAQSection';
import PageSEO from '@/components/seo/PageSEO';
import { useRecaptcha } from '@/hooks/useRecaptcha';

const contactStructuredData = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://afsprakenmaker.be/#organization",
    "name": "Afsprakenmaker",
    "description": "Het toonaangevende B2B callcenter in Vlaanderen gespecialiseerd in telemarketing en afspraken maken voor B2B-organisaties.",
    "url": "https://afsprakenmaker.be",
    "logo": "https://afsprakenmaker.be/logo-2026.png",
    "sameAs": [
      "https://www.facebook.com/afsprakenmaker",
      "https://www.linkedin.com/company/afsprakenmaker",
      "https://www.instagram.com/afsprakenmaker.be"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+32-800-90500",
      "contactType": "customer service",
      "availableLanguage": ["Dutch", "English"]
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Moorselbaan 391",
      "addressLocality": "Aalst",
      "postalCode": "9300",
      "addressCountry": "BE"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Wat maakt Afsprakenmaker het beste B2B callcenter in Vlaanderen?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Als toonaangevend B2B callcenter in Vlaanderen onderscheiden we ons door onze focus op kwaliteit boven kwantiteit, persoonlijke aanpak, en specifieke expertise in de Vlaamse markt. Onze telemarketeers zijn gespecialiseerd in het maken van relevante afspraken die daadwerkelijk tot verkoop leiden."
        }
      },
      {
        "@type": "Question",
        "name": "Hoe snel kunnen jullie starten met afspraken maken voor mijn bedrijf?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Na ons eerste gesprek kunnen we meestal binnen 5 werkdagen beginnen met jouw project. We zorgen voor een snelle opstart zonder in te boeten op kwaliteit."
        }
      }
    ]
  }
];

const Contact = () => {
  useRecaptcha();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <PageSEO
        title="Neem contact op met Afsprakenmaker | #1 B2B Callcenter in Vlaanderen"
        description="Direct contact opnemen met het beste B2B callcenter in Vlaanderen? Afsprakenmaker vult jouw agenda met kwalitatieve afspraken. Ontvang binnen 24u een persoonlijk groeiplan voor jouw organisatie."
        keywords="B2B callcenter Vlaanderen, B2B telemarketing, afspraken maken, telemarketing Vlaanderen, verkoopafspraken, sales outsourcing, B2B groeiplan, Aalst"
        canonicalUrl="/contact"
        structuredData={contactStructuredData}
      />
      <ContactHero />
      <ContactFormSection />
      <MapSection />
      <FAQSection />
    </div>
  );
};

export default Contact;
